/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import { Button, Form, Input, Modal, Popover, Select, Space, notification } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { ColDef } from 'ag-grid-community'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { RootDispatch } from '../../../app/store'
import {
  exportExchangeRecord,
  getExchangeRecordPage,
  getMembersDetail,
  refundMemberPointExchangeRecord
} from '../MembersManagementPageSlice'
import { getProcuctInfo } from '../columns'
import { selectSettings } from '../../user/setting/settingSlice'
import { DateSelect } from '../../../compnents/form/DateSelect'
import styles from '../MembersManagementPage.module.css'
import { getMaskPhone } from '../../../models/phone'

// 类型映射（与详情页一致）
const EXCHANGE_TYPE_MAP: Record<number, string> = {
  0: '兑换抵扣',
  1: '消费获得',
  2: '兑换退回',
  3: '退费退回',
  4: '积分清零',
}

export const ExchangeRecord = ( props:{
    SJHQXData?:any
}): React.ReactElement => {
  const dispatch = useDispatch<RootDispatch>()
  const settings = useSelector(selectSettings)
  const [form] = Form.useForm()

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
    keyWord: '',
    type: '',
    startTime: '',
    endTime: '',
  })

  const [page, setPage] = useState({ items: [], total: 0 })
  const [loading, setLoading] = useState(false)
  const [exportLoading, setExportLoading] = useState(false)

  const exportExcel = () => {
    setExportLoading(true)
    const { current, size, ...rest } = queries
    dispatch(exportExchangeRecord(rest))
      .then(unwrapResult)
      .then((res: any) => {
        const blob = new Blob([res])
        const fileName = '会员明细.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
        notification.success({ message: '导出成功', duration: 3 })
      })
      .catch(() => {
        notification.error({ message: '导出失败', duration: 3 })
      })
      .finally(() => setExportLoading(false))
  }

  const fetchData = () => {
    setLoading(true)
    dispatch(getExchangeRecordPage(queries))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records || [],
          total: res.total || 0,
        })
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
  }, [queries])

  const handleFinish = (values: any) => {
    setQueries({
      ...queries,
      current: 1,
      keyWord: values.keyWord || '',
      type: values.type ?? '',
      startTime: values.timeHead || '',
      endTime: values.timeTail || '',
    })
  }

  // 退货操作
  const handleRefund = (record: any) => {
    dispatch(refundMemberPointExchangeRecord({ id: record?.id }))
      .then(unwrapResult)
      .then(() => {
        notification.success({ message: '退货成功' })
        fetchData()
      })
      .catch(() => {
        notification.error({ message: '退货失败' })
      })
  }


  const openRefundConfirm = (record: any, memberExists: boolean) => {
    Modal.confirm({
      title: '确认退货',
      content: memberExists
        ? '退货后商品会自动退回到库存，积分会自动返回到用户账上'
        : '会员已不存在，商品退回后积分不退回，是否继续退回',
      maskClosable: false,
      okText: '确定',
      cancelText: '取消',
      onOk: () => handleRefund(record),
    })
  }

  const columnDefs: ColDef[] = [
    {
      field: 'no',
      headerName: '序号',
      width: 60,
      minWidth: 60,
      maxWidth: 60,
      flex: 0,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      valueGetter: (params) => {
        if (params.node?.rowIndex != null) {
          return queries.size * (queries.current - 1) + params.node.rowIndex + 1
        }
        return ''
      },
    },
    {
      field: 'name',
      headerName: '患者姓名',
      flex: 1,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      cellRendererFramework: function memberNameCell(params: any) {
        return (
          <span>
            {params.value}
            {Number(params.data?.memberDeleted) === 1 && (
              <span style={{ color: '#999999' }}>(已删除)</span>
            )}
          </span>
        )
      },
    },
    {
      field: 'phone',
      headerName: '手机号',
      flex: 1,
      minWidth: 120,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      cellRendererFramework: (params: any) => params.data?.phone ? (!props.SJHQXData ? getMaskPhone(params.data.phone) : params.data.phone) : '-',
    },
    {
      field: 'type',
      headerName: '类型',
      width: 110,
      minWidth: 110,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      valueFormatter: (params) => EXCHANGE_TYPE_MAP[Number(params.value)] ?? '-',
    },
    {
      field: 'itemName',
      headerName: '内容',
      flex: 1,
      minWidth: 280,
      sortable: false,
      cellStyle: { textAlign: 'left' },
      cellRendererFramework: function itemNameCell(params: any) {
        const r = params.data
        // resetType 1：固定日期清零 2：滚动日期清零（加粗展示）
        const resetType = Number(r?.resetType)
        if (resetType === 1) {
          return <span style={{ fontWeight: 'bolder' }}>固定日期清零</span>
        }
        if (resetType === 2) {
          return <span style={{ fontWeight: 'bolder' }}>滚动日期清零</span>
        }
        const type = Number(r?.type)
        // 消费获得：展示消费金额
        if (type === 1) {
          const price = r?.price
          return <span style={{ fontWeight: 'bolder' }}>消费{price != null && price !== '' ? `${price}元` : '-'}</span>
        }
        // 退费退回：展示退费金额
        if (type === 3) {
          const price = r?.price
          return <span style={{ fontWeight: 'bolder' }}>退费{price != null && price !== '' ? `${price}元` : '-'}</span>
        }
        const name = r?.itemName || r?.name || '-'
        const isGoods = Number(r?.catalogType) === 0
        const info = isGoods ? getProcuctInfo(r, settings || {}) : ''
        return (
          <Popover
            content={
              <div>
                <span style={{ fontSize: '14px', fontWeight: 'bolder', paddingRight: '15px' }}>{name}</span>
                {isGoods && <span style={{ color: '#999999', fontSize: '14px' }}>{info}</span>}
              </div>
            }
            placement="bottom"
          >
            <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              <span style={{ fontSize: '14px', fontWeight: 'bolder', paddingRight: '15px' }}>{name}</span>
              {isGoods && <span style={{ color: '#999999', fontSize: '14px' }}>{info}</span>}
            </div>
          </Popover>
        )
      },
    },
    {
      field: 'number',
      headerName: '兑换数量',
      width: 100,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      valueFormatter: (params) => {
        // 仅兑换抵扣(0)和兑换退回(2)显示数量，其他类型显示 -
        if (![0, 2].includes(Number(params.data?.type))) return '-'
        const val = params.data?.number
        return val == null || val === '' ? '-' : `${val}`
      },
    },
    {
      field: 'point',
      headerName: '积分变更',
      width: 100,
      minWidth: 100,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      valueFormatter: (params) => {
        const val = params.data?.point
        if (val == null || val === '') return '-'
        // type 0 3 4 使用负号 1 2 使用正号
        const sign = [0, 3, 4].includes(Number(params.data?.type)) ? '-' : '+'
        return `${sign}${val}`
      },
    },
    {
      field: 'remark',
      headerName: '备注',
      flex: 1,
      minWidth: 120,
      sortable: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'createTime',
      headerName: '兑换时间',
      flex: 1,
      minWidth: 160,
      sortable: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'createUserName',
      headerName: '操作员',
      flex: 1,
      minWidth: 80,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      valueFormatter: (params) => {
        if (Number(params.data?.type) === 4) return '系统自动'
        return params.value ?? '-'
      },
    },
    {
      field: 'action',
      headerName: '操作',
      width: 90,
      minWidth: 90,
      maxWidth: 90,
      flex: 0,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      cellRendererFramework: function ActionCell(params: any) {
        // 仅兑换抵扣(type 为 0)且 status 为 0 时才展示退货按钮
        if (Number(params.data?.type) !== 0 || params.data?.status !== 0)
          return <span></span>
        return (
          <Button
            type="link"
            style={{ padding: 0 }}
            onClick={() => {
              // 退货前根据 memberId 查询会员是否还存在
              dispatch(getMembersDetail(params.data?.memberId))
                .then(unwrapResult)
                .then((res: any) => {
                  // 会员存在则正常退货，不存在则提示积分不退回
                  openRefundConfirm(params.data, res?.id != null && res?.id != -1)
                })
                .catch(() => {
                  // 查询失败按会员不存在处理
                  openRefundConfirm(params.data, false)
                })
            }}
          >
            退货
          </Button>
        )
      },
    },
  ]

  return (
    <div className={styles.memberContents} style={{ margin: '0 0 5px 0', height: 'calc(100% - 10px)' }}>
      <Form form={form} onFinish={handleFinish}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <Space>
            <Form.Item name="keyWord" noStyle>
              <Input
                allowClear
                maxLength={20}
                style={{ width: '20rem' }}
                placeholder="请输入患者姓名/手机号/助记码"
                prefix={<SearchOutlined />}
                onChange={form.submit}
              />
            </Form.Item>
            <Form.Item name="type" noStyle>
              <Select
                allowClear
                placeholder="类型"
                style={{ width: 130 }}
                onChange={form.submit}
              >
                {Object.entries(EXCHANGE_TYPE_MAP).map(([k, v]) => (
                  <Select.Option value={Number(k)} key={k}>{v}</Select.Option>
                ))}
              </Select>
            </Form.Item>
            <DateSelect
              style={{ width: '8.5rem' }}
              labelPrefix=""
              namePrefix="time"
              placeholder="兑换时间"
              onChange={form.submit}
            />
            <Button type="primary" htmlType="submit" loading={loading}>
              查询
            </Button>
          </Space>
          <Space>
            <span style={{ color: '#999' }}>（最多支持导出10000条数据，更多请联系客服）</span>
            <Button type="primary" loading={exportLoading} onClick={exportExcel}>导出</Button>
          </Space>
        </div>
      </Form>
      <SimpleAgGrid
        column={columnDefs}
        page={{ items: page.items, current: queries.current, size: queries.size, total: page.total }}
        isLoading={loading}
        pagination={true}
        onChangePage={(current, size) =>
          setQueries({ ...queries, current, size })
        }
      />
    </div>
  )
}
